import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatRupiah } from "@/lib/api";
import { CheckCircle2, Star } from "lucide-react";
import { toast } from "sonner";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => {
      setOrder(r.data);
      if (r.data.rating) { setDone(true); setRating(r.data.rating); setComment(r.data.rating_comment || ""); }
    });
  }, [id]);

  const submit = async () => {
    if (rating === 0) return toast.error("Pilih bintang terlebih dahulu");
    setSubmitting(true);
    try {
      await api.post(`/orders/${id}/rate`, { rating, comment });
      toast.success("Terima kasih atas penilaiannya!");
      setDone(true);
    } catch { toast.error("Gagal mengirim penilaian"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F6] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-[#3A7D44]/10 flex items-center justify-center mx-auto mb-4">
          <CheckCircle2 className="w-10 h-10 text-[#3A7D44]" />
        </div>
        <h1 className="font-display text-3xl font-semibold text-[#1E3A2B]">Pesanan Diterima!</h1>
        <p className="text-[#5C6A61] mt-2">Pembayaran Anda sedang diverifikasi oleh kasir.</p>

        {order && (
          <div className="mt-6 bg-white rounded-2xl border border-[#EAE7DF] p-5 text-left">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#5C6A61]">Nomor Pesanan</span>
              <span className="font-semibold text-[#1E3A2B]" data-testid="success-order-no">#{order.order_no}</span>
            </div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#5C6A61]">Meja</span>
              <span className="text-[#1E3A2B]">{order.table_number}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-[#5C6A61]">Total</span>
              <span className="font-display font-semibold text-[#C25934]">{formatRupiah(order.total)}</span>
            </div>
          </div>
        )}

        <div className="mt-6 bg-white rounded-2xl border border-[#EAE7DF] p-5" data-testid="rating-card">
          <div className="font-display text-lg font-semibold text-[#1E3A2B]">
            {done ? "Terima kasih atas penilaian Anda" : "Bagaimana pengalaman Anda?"}
          </div>
          <div className="flex items-center justify-center gap-1 mt-3">
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                data-testid={`star-${n}`}
                disabled={done}
                onMouseEnter={() => !done && setHover(n)}
                onMouseLeave={() => !done && setHover(0)}
                onClick={() => !done && setRating(n)}
                className="p-1 disabled:cursor-default"
              >
                <Star
                  className={`w-8 h-8 transition-colors ${
                    (hover || rating) >= n ? "fill-[#D4A373] text-[#D4A373]" : "text-[#D3CEC4]"
                  }`}
                />
              </button>
            ))}
          </div>
          {!done && (
            <>
              <textarea
                data-testid="input-rating-comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows={2}
                placeholder="Komentar (opsional)"
                className="mt-3 w-full border border-[#D3CEC4] rounded-xl px-3 py-2.5 text-sm"
              />
              <button
                data-testid="btn-submit-rating"
                onClick={submit}
                disabled={submitting || rating === 0}
                className="mt-3 w-full bg-[#C25934] text-white py-2.5 rounded-xl font-medium disabled:opacity-50"
              >
                {submitting ? "Mengirim..." : "Kirim Penilaian"}
              </button>
            </>
          )}
          {done && comment && (
            <div className="mt-3 text-sm text-[#5C6A61] italic">"{comment}"</div>
          )}
        </div>

        <Link to="/" data-testid="btn-back-to-menu" className="inline-block mt-6 text-[#C25934] font-medium">
          Pesan Lagi
        </Link>
      </div>
    </div>
  );
}
